module.exports = __webpack_public_path__ + "res/ic_add_media_banner.efddf032c686294cee9e8fa9a3ab8bb7.png";